import React, { useEffect, useMemo, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import {
  logoutUser,
  getSessionExpiration,
  isSessionExpired,
} from "../../../Services/authService";
import { LI } from "../../../AbstractElements";

const formatRemaining = (ms) => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const hh = String(hours).padStart(2, "0");
  const mm = String(minutes).padStart(2, "0");
  const ss = String(seconds).padStart(2, "0");

  return `${hh}:${mm}:${ss}`;
};

const SessionStatus = () => {
  const [remainingMs, setRemainingMs] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [hasSession, setHasSession] = useState(false);

  const updateRemaining = () => {
    const expiration = getSessionExpiration();
    const token = localStorage.getItem("accessToken");

    if (!token) {
      setHasSession(false);
      setRemainingMs(0);
      return;
    }

    if (!expiration) {
      setHasSession(true);
      setRemainingMs(0);
      return;
    }

    const expirationTime = new Date(expiration).getTime();
    if (Number.isNaN(expirationTime)) {
      setHasSession(true);
      setRemainingMs(0);
      return;
    }

    setHasSession(true);
    setRemainingMs(Math.max(0, expirationTime - Date.now()));
  };

  useEffect(() => {
    updateRemaining();

    const intervalId = setInterval(updateRemaining, 1000);
    const handleSessionChange = () => updateRemaining();
    const handleStorage = (event) => {
      if (event.key === "sessionExpiration" || event.key === "accessToken") {
        updateRemaining();
      }
    };

    window.addEventListener("sessionChanged", handleSessionChange);
    window.addEventListener("storage", handleStorage);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("sessionChanged", handleSessionChange);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  useEffect(() => {
    if (hasSession && remainingMs <= 0 && isSessionExpired()) {
      setModalOpen(true);
    }
  }, [hasSession, remainingMs]);

  const formattedRemaining = useMemo(
    () => formatRemaining(remainingMs),
    [remainingMs],
  );

  const handleLogout = () => {
    setModalOpen(false);
    logoutUser();
    window.location.href = "/login";
  };

  if (!hasSession) return null;

  return (
    <>
      <LI className="session-status d-flex align-items-center me-3">
        <span className="session-status-label text-muted small">Oturum kalan süreniz: </span>
        <span className="ms-1 fw-semibold">{formattedRemaining}</span>
      </LI>

      <Modal isOpen={modalOpen} backdrop="static" keyboard={false} centered>
        <ModalHeader>Oturum Süresi Doldu</ModalHeader>
        <ModalBody>
          Oturum süreniz doldu. İşlem yapabilmek için tekrardan giriş yapmanız gerekmektedir.
        </ModalBody>
        <ModalFooter>
          <Button color="primary" className="w-100" onClick={handleLogout}>
            Giriş Sayfasına Dön
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SessionStatus;
